/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_table_find_driver = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find a driver... (e.g. VER+NOR)`)
};

const es_f1_table_find_driver = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar piloto... (ej. VER+NOR)`)
};

const de_f1_table_find_driver = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fahrer suchen... (z.B. VER+NOR)`)
};

const nl_f1_table_find_driver = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coureur zoeken... (bijv. VER+NOR)`)
};

const fr_f1_table_find_driver = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trouver un pilote... (ex. VER+NOR)`)
};

const it_f1_table_find_driver = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trova pilota... (es. VER+NOR)`)
};

const pt_br2_f1_table_find_driver = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar piloto... (ex. VER+NOR)`)
};

const pt_f1_table_find_driver = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encontrar piloto... (ex. VER+NOR)`)
};

const ja_f1_table_find_driver = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ドライバーを検索... (例: VER+NOR)`)
};

const zh_f1_table_find_driver = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查找车手...（如 VER+NOR）`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_table_find_driver = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_table_find_driver(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_table_find_driver", locale)
	if (locale === "en") return en_f1_table_find_driver(inputs)
	if (locale === "es") return es_f1_table_find_driver(inputs)
	if (locale === "de") return de_f1_table_find_driver(inputs)
	if (locale === "nl") return nl_f1_table_find_driver(inputs)
	if (locale === "fr") return fr_f1_table_find_driver(inputs)
	if (locale === "it") return it_f1_table_find_driver(inputs)
	if (locale === "pt-BR") return pt_br2_f1_table_find_driver(inputs)
	if (locale === "pt") return pt_f1_table_find_driver(inputs)
	if (locale === "ja") return ja_f1_table_find_driver(inputs)
	return zh_f1_table_find_driver(inputs)
};